export enum VrboHost2GuestReviewCategories {
  Overall = 'overall',
  Communication = 'communication',
  Cleanliness = 'cleanliness',
  HouseRules = 'house_rules',
}

export enum VrboGuest2HostReviewCategories {
  Overall = 'overall',
  EcoFriendliness = 'ecoFriendliness',
  RoomComfort = 'roomComfort',
  RoomCleanliness = 'roomCleanliness',
  Service = 'service',
  HotelCondition = 'hotelCondition',
  RoomAmenitiesScore = 'roomAmenitiesScore',
  AreaAroundHotel = 'areaAroundHotel',
}

export type VrboHost2GuestReviewPayload = {
  starRatings: {
    category: string
    value: string
  }[]
  recommendGuest: boolean
}
